import { Action, createReducer, on } from '@ngrx/store';
import { InvoiceState } from './state/invoice.state';
import { processInvoiceSuccess, processInvoiceFailure } from './actions/invoice.actions';

export const invoiceFeatureKey = 'invoice';

export const initialState: InvoiceState = {
    signalRLoading: undefined,
    processed: {
        error: undefined,
        invoiceId: undefined,
        batch: {
            id: undefined,
            index: undefined,
            totalCount: undefined
        }
    }
};

const InvoiceReducer = createReducer(
    initialState,

    on(
        processInvoiceSuccess,
        (state, action): InvoiceState => ({
            ...state,
            processed: {
                error: undefined,
                invoiceId: action.invoiceId,
                batch: { ...action.batch }
            }
        })
    ),

    on(
        processInvoiceFailure,
        (state, action): InvoiceState => ({
            ...state,
            processed: {
                error: action.error,
                invoiceId: undefined,
                batch: { ...action.batch }
            }
        })
    )
);

export function invoiceReducer(state: InvoiceState | undefined, action: Action) {
    return InvoiceReducer(state, action);
}
